// Module
var code = "<div ng-style=\"$ctrl.requirementStatus\"> <span class=\"br-body-2 font-weight-600 text-uppercase text-center\">{{$ctrl.status}}</span> </div> ";
// Exports
export default code;